export default __webpack_public_path__ + "static/media/clients-05.370ce652.svg";